import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Datepicker from 'react-tailwindcss-datepicker';
import { Search, Calendar, Download, Filter, Eye, Edit, Trash2, RefreshCw } from 'lucide-react';
import PlatformData from "../../../Json/subscriptiondevicetype.json"; // Direct import
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon, CircleStackIcon as CircleIcon } from "@heroicons/react/24/solid";
import apiService from '../../../apiService/Subscription/api-service';

const MetricsFilter = ({handleApply, onDateSelect, filters, setFilters, dateValue }) => {
    const [productList, setProductList] = useState([]);
    const [platformlist, setPlatformList] = useState([]);
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);

    async function getProductAllData() {
        const response = await apiService.fetchProducts();
        const data = response?.data?.data?.products || [];
        
        setProductList(data)
    }

    async function activeSubscriptionPlanData() {
        const response = await apiService.fetchPlans(filters?.productFilter);
        const data = response?.data?.data?.subscriptions || [];
        setSubscriptionPlans(data);
    }

    useEffect(() => {
        getProductAllData();
        setPlatformList(PlatformData);
    }, []);

    useEffect(() => {
        activeSubscriptionPlanData()

    }, [filters?.productFilter])

    return (
        <>
            <div className="bg-white rounded-lg shadow-sm mb-4">
                <div className="mb-4 border-b border-gray-300 px-6 py-4">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                        <div>
                            <h1 className="text-xl font-bold text-gray-900 mb-1">Subscription Metrics</h1>
                            <p className="text-sm text-gray-600">Monitor all subscription metrics and performance</p>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end px-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Date Range</label>
                        <div className="border border-gray-300 rounded-md shadow-sm">
                            <Datepicker
                                primaryColor={"red"}
                                value={dateValue}
                                onChange={newValue => onDateSelect(newValue)}
                                showShortcuts={true}
                                placeholder="Select date..."
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Product</label>
                        <select
                            value={filters?.productFilter} // use productFilter as the selected value
                            onChange={(productFilter) => { setFilters(prev => ({ ...prev, productFilter: productFilter.target.value })); }} // update state
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                                <option key="all_product" value="">All Product</option>
                                {productList.map((pl) => (
                                <option key={pl.id} value={pl.id}>{pl.product_name}</option>
                                ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Platform</label>
                        <select
                            value={filters?.platformFilter} // use productFilter as the selected value
                            onChange={(platform) => setFilters(prev => ({ ...prev, platformFilter: platform.target.value }))} // update state
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                                {platformlist.map((list) => (
                                <option key={list.id} value={list.slug}>{list.name}</option>
                                ))}
                        </select>
                    </div>
                    <div>
                        <Listbox value={filters?.planFilter} onChange={(plan) => { setFilters(prev => ({ ...prev, planFilter: plan })) }}>
                            <div className="relative">
                                <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm">
                                    <span className="block truncate text-gray-600">{filters?.planFilter.subscription_name || "Select Plan"}</span>
                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronUpDownIcon aria-hidden="true" className="size-5 text-gray-400" />
                                    </span>
                                </ListboxButton>

                                <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                    <ListboxOption
                                        key={'sp-0'}
                                        value={''}
                                        className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white">
                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">
                                            <span className="inline-block w-2.5 h-2.5 bg-green-600 rounded-full mt-1"></span>
                                            All Plans
                                        </span>
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                            <CheckIcon aria-hidden="true" className="size-5" />
                                        </span>
                                    </ListboxOption>
                                    {subscriptionPlans.map((list) => (
                                    <ListboxOption
                                        key={list.id}
                                        value={list}
                                        className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white">
                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">{list.status === 'active' && list.recurring_status === 'active' ? (
                                            <span className="inline-block w-2.5 h-2.5 bg-green-600 rounded-full mt-1"></span>
                                        ) : (
                                            <span className="inline-block w-2.5 h-2.5 bg-red-600 rounded-full mt-1"></span>
                                        )} {list.id} - {list.subscription_name} - {list.sell_price}</span>
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                            <CheckIcon aria-hidden="true" className="size-5" />
                                        </span>
                                    </ListboxOption>
                                    ))}
                                </ListboxOptions>
                            </div>
                        </Listbox>
                    </div>
                </div>

                <div className='flex justify-between items-center px-6 py-3 mt-5 border-t border-gray-300'>
                    <p className="text-xs text-blue-600">Note: Default data displayed is of current date. Use filters to refine results.</p>
                    <div className="md:col-span-2 flex justify-end gap-3">
                        <button
                            onClick={handleApply}
                            className="px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors flex items-center gap-2">
                            <Filter className="size-3.5" />Apply
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MetricsFilter